export default "__VITE_ASSET__BWlYn8Bx__"